import { useLangStore } from '../store/langStore';
import { translations } from './strings';

export { translations };
export type { Lang } from '../store/langStore';

export function useLang() {
  const { lang, setLang } = useLangStore();
  const t = translations[lang];
  return { lang, setLang, t };
}
